import Vue from "vue";
import queryString from 'query-string';

class NewsService {
    /**
     * @description Get list news priority 
     * @param {{per_page}} query 
     * @returns Promise
     */
    async getPriorityNews(query = {
        per_page: 3
    }) {
        try {
            return await Vue.axios({
                method: "GET",
                url: "/overview/news/priority",
                params: query
            });
        } catch (e) {
            return Promise.reject(e)
        }
    }

    /**
     * @description Get list news in overview api
     * @param {{seen}} data
     * @param {*} config
     * @returns Promise
     */
    async readNews(data = {}, config = {}) {
        try {
            return await Vue.axios.post("/overview/read-news", data, {
                ...config,
            });
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get list news
     * @param {{ currentPage ,keyword ,offer_id ,typeNews }} data Filter data sifting 
     * @returns Promise 
     */
    async news(data = {}) {
        try {
            return await Vue.axios.post('/overview/news', data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get detail of news with slug
     * @param {{slug}} data 
     * @returns Promise
     */
    async detailNews(data = {}) {
        try {
            return await Vue.axios.post("/overview/detail-news", data);
        } catch (e) {
            return Promise.reject(e)
        }
    }

    async updateLastReadNews(data = {}) {
        try {
            return await Vue.axios.put("/overview/update-last-read-news", data);
        } catch (e) {
            return Promise.reject(e)
        }
    }
}

const newsService = new NewsService();

export default newsService;


// WEBPACK FOOTER //
// ./src/core/services/newsService.js